import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import SimpleErrorBoundary from './components/SimpleErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import Approuter from './approuter';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SimpleErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <WebSocketProvider>
              <Approuter />
            </WebSocketProvider>
          </AuthProvider>
        </BrowserRouter>
      </SimpleErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;